import { RouterProvider } from "react-router-dom";
import ModalContainer from "./components/modal/modal-container";
import ToastContainer from "./components/toast/toast.container";
import router from "./router";
import "./styles/app.scss";
import Loading from "@core/components/loading";
import { useEffect } from "react";
import useObservable from "@core/hooks/use-observable.hook";
import HttpService from "@core/services/http/http.service";
import AccountService from "./services/http/account.service";
import { Subscription, catchError, throwError } from "rxjs";
import { useDispatch, useSelector } from "react-redux";
import { clearUser } from "./store/auth/auth.action";
import { clearMyInfo, storeMyInfo } from "./store/my-info/my-info.action";
import SocketService from "./services/socket.service";
import { RechargeStatusCode, SocketEvent } from "./constants";
import { GlobalState } from "./store";
import { addToast } from "./components/toast/toast.service";
import SupportChat from "./components/support-chat";

function App() {
  const dispatch = useDispatch();

  const { myInfo } = useSelector(selectMyInfo);
  const { subscribeUntilDestroy } = useObservable();

  const subscription = new Subscription();

  useEffect(() => {
    // Lấy đường dẫn hiện tại (ví dụ: /auth/confirm-account)
    const currentPath = window.location.pathname;

    const isConfirmAccount = currentPath.includes("confirm-account");
    const isChangePassword = currentPath.includes("change-password");

    // Chưa đăng nhập (trang chủ, đăng nhập, đăng ký) thì không hỏi /accounts/me, tránh toast 401 "Bạn cần xác thực"
    if (isConfirmAccount || isChangePassword || !HttpService.getAccessToken()) {
      return;
    } else {
      subscribeUntilDestroy(
        AccountService.getMyInfo().pipe(
          catchError((err) => {
            dispatch(clearUser());
            dispatch(clearMyInfo());

            return throwError(() => err);
          })
        ),
        (data) => {
          dispatch(storeMyInfo(data));
        }
      );
    }
  }, []);

  useEffect(() => {
    SocketService.connect();
  }, []);

  useEffect(() => {
    if (myInfo._id) {
      SocketService.emit(SocketEvent.JOIN_ROOM, myInfo._id);
    }
  }, [myInfo._id]);

  useEffect(() => {
    const sub = SocketService.onRechargeResult().subscribe((data) => {
      if (data.statusCode === RechargeStatusCode.FAILED) {
        addToast({ text: data.message, status: "inValid" });
      }

      if (data.statusCode === RechargeStatusCode.SUCCESS) {
        addToast({ text: data.message });

        subscribeUntilDestroy(
          AccountService.getMyInfo().pipe(
            catchError((err) => {
              dispatch(clearUser());
              dispatch(clearMyInfo());

              return throwError(() => err);
            })
          ),
          (accountRes) => {
            dispatch(storeMyInfo(accountRes));
          }
        );
      }
    });

    subscription.add(sub);
  }, [subscription]);

  useEffect(() => () => subscription.unsubscribe(), [subscription]);

  return (
    <>
      <RouterProvider router={router} />
      <div id="toast-root">
        <ToastContainer />
      </div>
      <div id="modal-root">
        <ModalContainer />
      </div>
      <div id="loading-root">
        <Loading />
      </div>
      {/* Nút hỗ trợ: Messenger, Discord, Chat trực tuyến (Subiz) gộp vào 1 nút */}
      <SupportChat />
    </>
  );
}

const selectMyInfo = (state: GlobalState) => state.myInfo;

export default App;
